'use strict';

import React, { Component } from 'react'

import UserCard from '@/UserCard'

import Modal  from '@Modal/Modal'

const app = window.app;

export default class UserCardModal extends Component
{
	state =
	{
		open: false
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__UserCardModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'open__UserCardModal',
			cb: component.open
		});
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open: false
		});
	}

	open = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		let output =
		(
			<Modal open={ state.open } onClose={ component.handleClose }
				title="Ma carte Synergies" hide_close={ true }
				className="o-modal o-modal--user-card" invisible>

				<UserCard className="in-modal" hide-guide />

			</Modal>
		);

		return output;
	}
}
